"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavVerticalGroupComponent = /** @class */ (function () {
    function FuseNavVerticalGroupComponent() {
        this.classes = 'nav-group nav-item';
    }
    return FuseNavVerticalGroupComponent;
}());
exports.FuseNavVerticalGroupComponent = FuseNavVerticalGroupComponent;
